import VueSpeedometer from "vue-speedometer"

if ($('#speedometer').length) {
    const textColor = "#FF6964"
    var app = new Vue({
        el: '#speedometer',
        data: {
            score: score
        },
        components: {VueSpeedometer},
        template: `
          <vue-speedometer
              :value=this.score
              currentValueText="\${value}%"
              textColor="${textColor}"
              :minValue=0
              :maxValue="100"
              :maxSegmentLabels="0"
              :needleHeightRatio="0.75"
              valueTextFontSize="32px"
              valueTextFontWeight="bold"
              :paddingVertical="25"
              needleColor="${textColor}"
              :segments="50"
              :ringWidth="40"
              :height="210"
          />`,
    });
}


